import { ErrorMessage, Field } from 'formik';
import { FunctionComponent } from 'react';

import styles from './styles.module.css';

export enum InputTheme {
  MATERIAL,
  CUSTOM,
}

interface InputDateProps {
  className?: string;
  disabled?: boolean;
  min?: string;
  name: string;
  theme?: InputTheme;
  title?: string;
  value?: string | number;
}

const InputDate: FunctionComponent<InputDateProps> = ({
  className = '',
  disabled,
  theme = InputTheme.MATERIAL,
  min,
  name,
  title,
  value,
}) => {
  const themeClass = {
    [InputTheme.MATERIAL]: {
      input: styles.textDate,
      bar: styles.bar,
      tag: styles.tag,
      error: styles.invalid,
    },
    [InputTheme.CUSTOM]: {
      input:
        'shadow-bs-mvs-input border-mvs-border-lighter leading-none text-body-14 focus:border-mvs-border-main focus:outline-none',
      bar: '',
      tag: '',
      error: 'border-solid border-mvs-border-negative text-mvs-text-negative',
    },
  };

  const currentThemeStyle = themeClass[theme];

  return (
    <Field name={name}>
      {({ field, meta }) => (
        <div className={`relative ${disabled ? 'opacity-60' : ''} `}>
          {theme === InputTheme.CUSTOM && (
            <span
              className={`text-sm font-aeonik text-body-14 ${
                meta.error && meta.touched
                  ? 'text-mvs-text-negative'
                  : 'text-mvs-text-secondary'
              }`}
            >
              {title}
            </span>
          )}

          <input
            {...field}
            className={`${
              meta.touched && meta.error ? currentThemeStyle.error : ''
            } ${currentThemeStyle.input} ${className} font-aeonik`}
            disabled={disabled}
            type="date"
            min={min}
            required
            value={value}
          />

          {theme === InputTheme.MATERIAL && (
            <>
              <span
                className={`${
                  meta.touched && meta.error ? currentThemeStyle.error : ''
                } ${currentThemeStyle.bar}`}
              ></span>
              <label className={`${currentThemeStyle.tag} font-aeonik`}>
                {title}
              </label>
              <ErrorMessage
                name={name}
                component="span"
                className={`${currentThemeStyle.error} block text-xs text-danger-40`}
              />
            </>
          )}

          {theme === InputTheme.CUSTOM && meta.touched && meta.error && (
            <span
              className={`${currentThemeStyle.error} text-xs text-mvs-text-negative`}
            >
              {meta.error}
            </span>
          )}
        </div>
      )}
    </Field>
  );
};

export default InputDate;
